import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import styles from "./index.module.scss";
import NotesList from "./notes-list";
import CallRecordsList from "./call-records-list";
import PropertiesList from "./properties-list";

export default function InvestorDetailsTabs({
  accountId,
  propertyId,
  checkoutId
}: {
  accountId: string;
  propertyId: string;
  checkoutId: string;
}) {
  return (
    <div className={styles.tabsWrapper}>
      <TabView
        className={styles.invTabs}
        panelContainerClassName={styles.tabPanels}
        renderActiveOnly={false}
      >
        <TabPanel
          header={<span className={styles.tabHeader}>My Notes</span>}
          className={styles.tabPanel}
        >
          <NotesList
            showActions={true}
            accountId={accountId}
            propertyId={propertyId}
          />
        </TabPanel>
        <TabPanel
          header={<span className={styles.tabHeader}>Public Notes</span>}
          className={styles.tabPanel}
        >
          <NotesList
            type={"public"}
            showActions={false}
            accountId={accountId}
            propertyId={propertyId}
          />
        </TabPanel>
        <TabPanel
          header={<span className={styles.tabHeader}>Call Records</span>}
          className={styles.tabPanel}
        >
          <CallRecordsList accountId={accountId}
            propertyId={propertyId} />
        </TabPanel>
        <TabPanel
          header={<span className={styles.tabHeader}>Eligible Properties</span>}
          className={styles.tabPanel}
        >
          <PropertiesList accountId={accountId}/>
        </TabPanel>
      </TabView>
    </div>
  );
}
